import { GET_TABLE } from './index'

export const requestAlarmManagerTable = (payload) => ({
  type: GET_TABLE.REQUEST,
  payload,
})

export const successAlarmManagerTable = (payload) => ({
  type: GET_TABLE.SUCCESS,
  payload,
})

export const errorAlarmManagerTable = (payload) => ({
  type: GET_TABLE.ERROR,
  payload,
})
